<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:32:47
 * @LastEditTime: 2025-09-05 01:21:15
-->
<template>
  <div class="listPost">
    <van-overlay :show="digshow" @click="">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="dig_titile">精准匹配岗位</div>
          <van-form @submit="onSubmit" style="width: 90%;margin: 0 auto;margin-top: 40px;">
            <div style="line-height: 30px;font-weight: bold;" class="roule">手机号：</div>
            <van-field v-model="phone" placeholder="请输入您的报考手机号"
              style="border: 1px #ebedf0 solid;border-radius: 10px;" />
            <!-- <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }]" /> -->
            <div style="margin: 16px;margin-top: 30px;">
              <van-button round block type="danger" native-type="submit" :loading="isbtn">查询</van-button>
            </div>
          </van-form>
          <div class="text1">请输入您报考时填写的手机号，来确定您的个人信息，进行精准匹配岗位。</div>
        </div>
      </div>
    </van-overlay>
    <div class="ui-content" style="margin-top: 16px">
      <section class="record-list">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="onLoad"
            offset="20" error-text="请求失败，点击重新加载">
            <li v-for="item in list" :key="item.index" class="li-items">
              <p :style="{fontSize: '16px', position: 'relative', padding: '0px 10px', fontWeight: item.isKeyCompany ? 'bold' : ''}"
              >
                {{ item.companyName }}
              </p>
              <div style="margin: 10px">
                <div class="title">
                  {{ item.workPost }}

                  <div class="ribbon" v-if="item.companyType == 2">
                    <div class="ribbon-text">大厂</div>
                  </div>
                </div>
                <div class="items-content">
                  <p class="tag">
                    <van-tag type="primary" style="margin-right: 10px">{{
                      item.postTypeDesc
                    }}</van-tag>
                    <van-tag type="primary" style="margin-right: 10px">{{
                      item.backgroundDesc
                    }}</van-tag>
                    <van-tag type="primary" style="margin-right: 10px">{{
                      item.graduationYear
                    }}</van-tag>
                  </p>

                  <ol>
                    <li>
                      <span class="label">涉及专业：</span>
                      <span class="label-content" style="line-height: 16px;">{{ item.major }}</span>
                    </li>
                    <li>
                      <span class="label">起止时间：</span>
                      <span class="label-content">{{ item.applyStartDate }} -
                        {{ item.applyEndDate }}</span>
                    </li>
                    <li>
                      <span class="label">所在城市：</span>
                      <span class="label-content">{{ item.city }}</span>
                    </li>
                    <li>
                      <span class="label">应试要求：</span>
                      <span class="label-content">{{ item.postRequire }}</span>
                    </li>
                  </ol>
                </div>
                <div class="items-content-footer">
                  <van-icon :name="item.isCollect ? 'star' : 'star-o'" size="20" :color="item.isCollect ? 'orange' : ''"
                    @click="postCollect(item)" />

                  <van-button type="info" size="small" round @click="copyUrl(item)">报考链接</van-button>
                </div>
              </div>
            </li>

            <!-- 加载状态提示 -->
            <template #loading>
              <div class="loading-text">加载中...</div>
            </template>
          </van-list>
        </van-pull-refresh>
      </section>
    </div>


    <van-dialog v-model="show" title="公告出岗情况">
      <div style="height: 280px;overflow: auto;padding: 10px;">
        <van-list
          v-model="loading1"
          :finished="finished1"
          finished-text="没有更多了"
          @load="onLoad1"
          :immediate-check="false"
        >
          <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
          <li v-for="i,index in countList" :key="index" :class="['infinite-list-item', i.isBold ? 'fontWeight' : '']" style="display:flex;margin: 10px 0px;align-items:center;flex-wrap: wrap;height: 24px;margin:10px 0px;">
              {{i.companyName}} 近<p style="color: red;">7天</p>更新<p style="color: red;">{{i.count}}个</p>岗位
          </li>
        </van-list>
      </div>
    </van-dialog>

    <van-dialog v-model="show1" title="投递信息复盘">
      <div style="padding: 20px;">
        <b>同学你好，您的投递情况情况如下:</b>
        <li style="display:flex;margin: 10px 0px;align-items:center;">
            近<p style="color: red;">7天</p>更新的岗位数量 <p style="color:red;">{{currentModal2.importCount}}个</p>
        </li>
        <li style="display:flex;margin: 10px 0px;align-items:center;">
            近<p style="color: red;">7天</p>符合报考的数量 <p style="color:red;">{{currentModal2.postCount}}个</p>
        </li>
        <li style="display:flex;margin: 10px 0px;align-items:center;">
            近<p style="color: red;">7天</p>您的投递的数量 <p style="color:red;">{{currentModal2.sendCount}}个</p>
        </li>
        <p>
            求职是一场““持久战”，与其纠结“这个岗位该不该投”，不如先投出去 - 即使没通过，也是为下一次成功积累经验;而如果因为犹豫错过，可能就少了一个改变的机会。
        </p>
      </div>
    </van-dialog>




  </div>
</template>

<script>
import Vue from 'vue'
import { postList, getPostFilter, postCollect, myCollectList, experiencePostList, getUserPostFilter, experienceModalCounts, experienceModalStatistics, applicationApply } from '@/api/xicaiquan'
import { Tag, List, PullRefresh, Button, Toast, Dialog } from 'vant'
Vue.use(Tag)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Button)
Vue.use(Dialog)
export default {
  name: 'listPost',
  props: {
    type: String,
    form: Object
  },
  data() {
    return {
      digshow: true,
      isbtn:false,
      phone: '',
      list: [1, 2, 3], // 列表数据
      loading: false, // 列表加载状态
      finished: false, // 列表是否加载完成
      isLoading: false, // 下拉刷新状态
      page: 1, // 当前页码
      pageSize: 10, // 每页条数
      queryParams: {
        code: '199199', //199199
        current: 1,
        size: 10
      },
      current: 1,
      size: 10,
      show: false,
      show1: false,
      loading1: false,
      finished1: false,
      currentModal2: {},
      countList: [],
      modal1Total: 0
    }
  },
  created() {
    // if (this.type == "precisePost") {
    //   this.getPostFilter();
    // }
    // this.list = [];
    document.documentElement.scrollTop = 0
    window.pageYOffset = 0
    document.body.scrollTop = 0


  },
  components: {},
  watch: {},
  methods: {
    async onSubmit() {
      // return
      if (this.phone == '') { return Toast('请填写手机号') }
      const res = await getUserPostFilter({ phone: this.phone })
      if (res.code == '200') {
        Object.assign(this.queryParams, res.data)
        this.loadData()
         this.isbtn=true

        this.handleModal1(true)
        this.handleModal2()


      }else{
         this.isbtn=false
      }


      // console.log(res1);
      // return (res1.data && res1.data.records) || []
    },
    async getData() {
      if (this.type == 'precisePost') {
        // const res = await getUserPostFilter({ phone: '19919910664' })
        // Object.assign(this.queryParams, res.data)
        const res1 = await experiencePostList(this.queryParams)
         this.digshow = false
         this.isbtn=false
         if(this.queryParams.current=='1'){
           Toast({ message:`累计匹配岗位${res1.data.total}条`, position: 'bottom', className: 'custom-toast', });

         }
        // console.log(res1);
        return (res1.data && res1.data.records) || []
      }

      // if (this.type == 'intelligencePost') {
      //   Object.assign(this.queryParams, this.form)

      //   if (!this.queryParams.graduationYear[0]) return
      //   if (!this.queryParams.postType[0]) return
      //   if (!this.queryParams.graduationYear[0]) return

      //   const res1 = await experiencePostList(this.queryParams)
      //   console.log("res1", res1)
      //   // console.log(res1);
      //   return (res1.data && res1.data.records) || []
      // }

      // if (this.type == "myCollect") {
      //   const res1 = await myCollectList(this.queryParams)
      //   // console.log(res1);
      //   return (res1.data && res1.data.records) || []
      // }

      // console.log(this.queryParams, "sdfdsfsd");
    },

    // 加载数据
    async loadData() {
      try {
        const data = await this.getData()
        console.log('data111', data)

        if (data) {
          // 如果是第一页，直接替换数据
          if (this.queryParams.current === 1) {
            this.list = data
          } else {
            // 否则追加数据
            this.list = [...this.list, ...data]
          }

          // 判断是否还有更多数据
          if (data.length < this.queryParams.size) {
            this.finished = true
          }
        }

      } catch (error) {
        console.error('加载数据失败:', error)
      } finally {
        this.loading = false
        this.isLoading = false
      }
    },

    // 列表滚动到底部时触发
    onLoad() {
      if (this.finished) return

      console.log("执行的。。。。。")
      this.queryParams.current++
      this.loadData()
    },
    onLoad1() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      if (this.countList.length >= this.modal1Total) {
          return;
      }
      this.handleModal1()

    },

    // 下拉刷新触发
    onRefresh() {
      this.queryParams.current = 1
      this.finished = false
      this.loading = true
      this.loadData()
    },

    // 收藏
    async postCollect(item) {
      const res = await postCollect({ id: item.id, isCollect: !item.isCollect })
      if (res.code == 200) {
        if (item.isCollect) {
          Toast('已取消收藏')
        } else {
          Toast('收藏成功')
        }
      }

      item.isCollect = !item.isCollect
    },
    copyUrl(row) {
      

      Dialog.confirm({
        title: '温馨提示',
        message: '确定复制链接并投递吗？',
      })
      .then(() => {
        // 创建一个临时的文本输入框
        const tempInput = document.createElement('input')
        // 将需要复制的内容赋值给输入框
        tempInput.value = row.sendLink
        // 将输入框添加到文档中
        document.body.appendChild(tempInput)
        // 选中输入框的内容
        tempInput.select()
        // 执行复制命令
        document.execCommand('copy')
        // 从文档中移除临时输入框
        document.body.removeChild(tempInput)

        Toast('复制成功')

        applicationApply({id: row.id}).then(res1 => {

        })
        // on confirm
      })
      .catch(() => {
        // on cancel
      });


    },
    async handleModal1(flag) {
        this.loading1 = true; 
        const res = await experienceModalCounts({current: this.current, size: this.size, phone: this.phone})
        if (res.code == 200) {
          this.loading1 = false;
          this.modal1Total = res.data.total;
          if (res.data.records.length) {
            this.countList.push(...res.data.records);

            if (flag) {
                this.show = true;
            }

            if (this.countList.length >= this.modal1Total) {
              this.finished1 = true;
            } else {
              this.finished1 = false;
            }
            // this.finished1 = res.data.records.length < 10;

            this.current ++
          } else {
            this.loading1 = false;



            if (this.countList.length >= this.modal1Total) {
              this.finished1 = true;
            } else {
              this.finished1 = false;
            }


            if (flag) {
                this.show = false;
            }
          }

        } else {
          this.loading1 = false;
        }
        

        console.log("loading1", this.loading1)
    },
    async handleModal2() {
        const res = await experienceModalStatistics({phone: this.phone})
        if (res.data.importCount == 0 && res.data.postCount == 0 && res.data.sendCount == 0) {
          this.show1 = false;
        } else {
          this.show1 = true
        }
        this.currentModal2 = res.data;
        console.log(res)
    },
  }
}
</script>
<style scoped lang="scss">
.wrapper {
  display: flex;
  // align-items: center;
  margin-top: 20vh;
  justify-content: center;
  // height: 100%;
}

.dig_titile {
  font-size: 16px;
  line-height: 50px;
  width: 100%;
  text-align: center;
  color: rgb(224, 32, 32);
  font-weight: bold;
}

.text1 {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  line-height: 20px;
  margin-top: 40px;
  color: #969799;
}

.block {
  width: 90%;
  // height: 40vh;
  // height: 40%;
  background-color: #fff;
  border-radius: 10px;
  padding-bottom: 40px;
}

.listPost {
  width: 100%;

  .ui-content {
    width: 95%;
    margin: 0px auto;

    .li-items {
      border-radius: 10px;
      background: #fff;
      margin-bottom: 20px;

      p {
        border-bottom: 1px solid #ddd;
        line-height: 40px;
        padding: 10px;
      }

      .title {
        background: #e0edfe;
        border-radius: 10px 10px 0px 0px;
        line-height: 40px;
        font-size: 16px;
        text-indent: 20px;
        margin-top: 20px;
        position: relative;
        overflow: hidden;
        padding-right: 10px;
        text-overflow: ellipsis;
        white-space: nowrap;

        .ribbon {
          width: 80px;
          height: 40px;
          background: orange;
          position: absolute;
          top: 0;
          right: -25px;
          transform: rotate(34deg);
          transform-origin: top right;
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
        }

        .ribbon-text {
          position: absolute;
          top: 12px;
          right: 12px;
          color: white;
          font-weight: bold;
          font-size: 12px;
          transform: rotate(0deg);
          transform-origin: right center;
          font-family: 'Arial', sans-serif;
        }

        /* 可选：让角标右上角带圆角 */
        .ribbon::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 12px;
          height: 12px;
          background: white;
          border-top-left-radius: 12px;
        }
      }

      .items-content {
        background: #fafbff;
        padding: 20px;

        .tag {
          display: flex;
        }

        ol {
          margin: 20px 0px;

          li {
            display: flex;
            margin: 20px 0px;

            .label {
              color: #999;
              white-space: nowrap;
            }

            .label-content {}
          }
        }
      }

      .items-content-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ddd;
        padding: 14px 10px;
        background: #fafbff;
      }
    }
  }
}
</style>
